import {Component, Input, OnInit} from '@angular/core';
import {PartnerApiKey, PartnerApiKeyAddModel, PartnerApiKeyType} from "../../../dto/partner-api-key";
import {MatDialog} from '@angular/material/dialog';
import {CompanyService} from '../../services/company.service';
import {AddApikeyDialogComponent} from './add-apikey-dialog/add-apikey-dialog.component';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';
import {Company} from '../../../dto/company';
import {DisplayApikeyDialogComponent} from './display-apikey-dialog/display-apikey-dialog.component';

@Component({
  selector: 'app-company-api-settings',
  templateUrl: './company-api-settings.component.html',
  styleUrls: ['./company-api-settings.component.css']
})
export class CompanyApiSettingsComponent implements OnInit {

  @Input() company: Company;
  public apiKeys: PartnerApiKey[];

  constructor(
    private dialog: MatDialog,
    private companyService: CompanyService,
    ) { }

  partnerApiKeyType = PartnerApiKeyType;

  ngOnInit() {
    this.loadApiKeys();
  }

  disableApiKey(apiKeyId: string) {
    this.companyService.disableApiKey(apiKeyId).subscribe(data => {
      this.loadApiKeys();
    });
  }

  enableApiKey(apiKeyId: string) {
    this.companyService.enableApiKey(apiKeyId).subscribe(data => {
      this.loadApiKeys();
    });
  }

  deleteApiKey(apiKeyId: string) {

    this.dialog.open(ConfirmDialogComponent).afterClosed().subscribe(result => {
      if (result == 'ok') {
        this.companyService.deleteApiKey(apiKeyId).subscribe(data => {
          this.loadApiKeys();
        });
      }
    });


  }

  addApiKey() {


    this.dialog.open(AddApikeyDialogComponent, { minWidth: 400 }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof PartnerApiKeyAddModel) {
          dlgResult.companyId = this.company.id;

          this.companyService.createApiKey(dlgResult).subscribe(result => {
            console.log('api key is: ' + result);
            this.loadApiKeys();
            // display api key
            this.displayApiKey(result);
          });

        }
      });
  }

  private loadApiKeys() {
    this.companyService.getApiKeys(this.company.id).subscribe(data => {
      this.apiKeys = data;
    });
  }

  private displayApiKey(result: string) {

    this.dialog.open(DisplayApikeyDialogComponent, {
      data: {apiKeyPlain: result},
    });
  }

  editApiKey(apiKeyId: string) {

    this.companyService.getApiKey(this.company.id, apiKeyId).subscribe(apiKey => {
      this.dialog.open(AddApikeyDialogComponent, { minWidth: 400, data: {permissions: apiKey.permissions, apiKeyId: apiKey.apiKeyId, comment: apiKey.comment} }).afterClosed()
        .subscribe(dlgResult => {
          if (dlgResult instanceof PartnerApiKeyAddModel) {
            dlgResult.companyId = this.company.id;
            const newPermissions = dlgResult.permissions;
            const newComment = dlgResult.comment;
            const newApiKeyType = dlgResult.apiKeyType;
            this.companyService.updatePartnerApiKey(apiKeyId, newPermissions, newComment, newApiKeyType).subscribe(result => {
              console.log('api key permissions changed');
              this.loadApiKeys();
            });

          }
        });
    });


  }
}
